<template>
  <fragment>
    <component
      v-if="jobQuestion"
      :is="componentData.name"
      :key="jobQuestion.id"
      :loading-detail="componentData.loadingDetail"
      v-bind="componentData.props"
      @set-criteria-value="onSetCriteriaValue"
      @update-criteria-value="onUpdateCriteriaValue"
      @clear-criteria-value="onClearCriteria"
      @set-terms-value="onSetTermValue"
      :filter-user-count="filterUserCount"
      :criteria-items="criteriaItems"
      :criteriaJobQuestions="criteriaJobQuestions"
      :job_opportunity_duration="this.job_opportunity_duration"
      :job_opportunity_price="this.job_opportunity_price"
      @isJobInfoActive="$emit('isJobInfoActive', $event)"
      @save-details="$emit('save-details', $event)"
      @show-connect-opp-btn="$emit('show-connect-opp-btn', $event)"
      :job-builder-landing-content="jobBuilderLandingContent"
    />
  </fragment>
</template>

<script>
import RecruiterIcoDetailLocation from '@/components/recruiter/ico/criteria/detail/RecruiterIcoDetailLocation';
import RecruiterIcoDetailSpecialty from '@/components/recruiter/ico/criteria/detail/RecruiterIcoDetailSpecialty';
import RecruiterIcoDetailJobQuestion from '@/components/recruiter/ico/criteria/detail/RecruiterIcoDetailJobQuestion';
import RecruiterIcoDetailJobInformation from '@/components/recruiter/ico/criteria/detail/RecruiterIcoDetailJobInformation';
import JobInformationInput from '@/components/recruiter/exchange/create-job-offer/job-offer-input/JobInformationInput';

//import JobInformationForm from "@/components/recruiter/form/JobInformationForm";

import { JOB_QUESTION_TYPES } from '@/store';

export default {
  name: 'RecruiterIcoCriteriaDetail',
  components: {
    RecruiterIcoDetailSpecialty,
    RecruiterIcoDetailLocation,
    RecruiterIcoDetailJobQuestion,
    RecruiterIcoDetailJobInformation,
    JobInformationInput
  },
  props: {
    jobQuestion: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    loadingDetail: {
      type: Boolean,
      default: false,
    },
    saveLabel: String,
    jobOffer: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    filterUserCount: {
      type: Boolean,
      default: false,
    },
    isOtherCriteriaDisabled:{
      type: Boolean,
    },
    practiceTypeFlag:{
      type: Boolean,
    },
    maxCompFlag:{
      type: Boolean,
    },
    job_opportunity_price:{
      type: String,
    },
    job_opportunity_duration:{
      type: String,
    },
    criteriaItems: {
      type: Array,
      default: function () {
        return [];
      },
    },
    criteriaJobQuestions:{
      type : Array,
    },
    jobBuilderLandingContent:{
      type: Array,
    }
  },
  computed: {
    componentData: function () {
      switch (this.jobQuestion.talent_type) {
        case JOB_QUESTION_TYPES.LOCATION:
          return {
            name: RecruiterIcoDetailLocation.name,
            props: {
              jobQuestion: this.jobQuestion,
              loadingDetail: this.loadingDetail,
            },
          };
        case JOB_QUESTION_TYPES.SPECIALTY:
          return {
            name: RecruiterIcoDetailSpecialty.name,
            props: {
              jobQuestion: this.jobQuestion,
              loadingDetail: this.loadingDetail,
              saveLabel: this.saveLabel
            },
          };
        case JOB_QUESTION_TYPES.JOB_INFORMATION:
          return {
            name: JobInformationInput.name,
            props: {
              jobQuestion: this.jobQuestion,
              loadingDetail: this.loadingDetail,
              actionName: 'save-details',
            },
          };
        default:
          return {
            name: RecruiterIcoDetailJobQuestion.name,
            props: {
              jobQuestion: this.jobQuestion,
              loadingDetail: this.loadingDetail,
            },
          };
      }
    },
  },
  methods: {
    onSetCriteriaValue: function (params) {
      this.$emit('set-criteria-value', params);
    },
    onUpdateCriteriaValue: function (params) {
      this.$emit('update-criteria-value', params);
    },
    onSetTermValue: function (params) {
      this.$emit('set-terms-value', params);
    },
    onClearCriteria: function (params) {
      this.$emit('clear-criteria-value', params);
    },
  },
};
</script>

<style scoped />
